import {defineMessages} from "react-intl";

const messages = defineMessages({
  editMe: {
    description: "Edit this description",
    defaultMessage: "Edit me!",
    id: "ElectrifyReact.asda.editMe"
  }
});

module.exports = messages;



// WEBPACK FOOTER //
// ./src/lang/tenants/asda/default-messages.js